/*
 * הסיבוב בתוך רצועת הקדם השקה. ראו sections/ty-cs-hero.liquid.
 * בקשת יובל 16.09.2026: «במקום שהחלקה והחצים יעברו בין תמונות, שיסובבו את הטלפון».
 *
 * ── גרסה 3, 17.09.2026: המנוע של גרסה 5 בדף הבדיקה ─────────────────────────
 * הספר: docs/cs-hero-spin-2026-09-16/HANDOFF-2026-09-17.md (בריפו shopify-agent).
 *
 * 🔴 תמונה שלמה אחת בכל ציור, בלי ערבוב בין זוויות. הערבוב של גרסה 2 הוא
 *    שיצר את «הטלפון הכפול». 120 זוויות, כלומר צעד של 3 מעלות.
 * 🔴 ציור ישר מ-<img> שעבר decode(), בלי createImageBitmap. ב-WebKit הביטמפ
 *    נבנה על התהליך הראשי, כ-16ms לתמונה, והסיבוב נעצר עד 507ms.
 * 🔴 צפיפות הקנבס עד 3. זה ההבדל שיובל ראה באייפון בין גרסה 4 ל-5.
 * 🔴 טעינה: הזווית הראשונה מיד (preload בליקוויד). כל השאר רק אחרי אירוע load
 *    של הדף, כדי לא לגעת ב-LCP. קודם 20 זוויות הנדנוד, ואחריהן השאר.
 * 🔴 נדנוד פתיחה: קשת של עד 30 מעלות לכל צד, ורק על זוויות שכבר נטענו.
 *    נגיעה עוצרת אותו. בלי נדנוד ל-prefers-reduced-motion.
 * 🔴 צבעים אחרים ברקע (הכרעת יובל 17.09.2026): רק אחרי load ואחרי שהצבע
 *    הראשון מוכן כולו · צבע אחד בכל פעם · דחוסים בלבד (blob), בלי פענוח ·
 *    נעצר כשהלקוח עוזב את הדף, ומושהה כשהלשונית ברקע.
 *    ‏?spinbg=0 מכבה את זה, בשביל מדידת Lighthouse בלבד.
 * 🔴 בזיכרון מפוענח רק הצבע שעל המסך. בהחלפה: הזווית הנוכחית קודם, ואז השכנות.
 *    הצבע הקודם משתחרר כשהשפיכה נגמרת.
 * 🔴 Accept מפורש ב-fetch: ה-CDN מנהל משא ומתן על הפורמט (vary: Accept),
 *    ו-fetch רגיל מקבל PNG כבד פי 12.
 * 🔴 אפס כתיבות ל-DOM בכל פריים. המצב לבדיקה: root.__tychSpin.
 * 🔴 אפס שינוי בקוד הרצועה. הקנבס תופס את ההחלקה בעצמו, והחצים נתפסים בשלב
 *    הלכידה. נכשל בטעינה ⟹ הגלריה הישנה נשארת.
 * 📊 ‏?spindebug=1 מציג על המסך את טבלת המדידה של דף הבדיקה.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var Q = window.location.search;
  var DEBUG = /[?&]spindebug=1(&|$)/.test(Q);
  var NOBG = /[?&]spinbg=0(&|$)/.test(Q);
  /* 📏 17.09.2026, מתגי בדיקה בלבד. בלי הפרמטר, ההתנהגות זהה לגרסה שנבחרה.
     ?spinearly=1  הנדנוד והטעינה מתחילים כשהטלפון כבר צויר והדפדפן פנוי, ולא ב-load.
                   ב-load בדף הזה מחכים גם ל-Clarity ולפיקסלים (נמדד 10 עד 35 שניות).
                   הצבעים האחרים עדיין מחכים ל-load, לפי הכרעת יובל.
     ?spinset=1350 הסט החד (864 על 1350), רק לגימורים שרשומים ב-SHARP.
     ?spindraft=0  מכבה את הטיוטה. **היא דולקת כברירת מחדל מ-20.09.2026**, בהכרעת יובל,
                   כי בלעדיה הסיבוב «נתקע» עד שהזוויות המלאות מגיעות. הכיבוי הוא למדידה בלבד.
     הטיוטה: 40 זוויות קטנות (256 על 400) בתמונה אחת, `ty-spin3-<דגם>-<גימור>-draft.webp`.
                   נטענת מיד אחרי שהטלפון צויר, כדי שאפשר יהיה לסובב בשניות הראשונות.
                   יובל 17.09.2026: «נתקע מאוד בהתחלה, לוקח איזה חמש שניות». זווית מלאה גוברת עליה
                   תמיד, והיא משתחררת מהזיכרון כשכל 120 הזוויות המלאות מוכנות. */
  var EARLY = /[?&]spinearly=1(&|$)/.test(Q);
  var DRAFT = !/[?&]spindraft=0(&|$)/.test(Q);
  var DRAFT_N = 40, DRAFT_COLS = 8, DRAFT_W = 256, DRAFT_H = 400;
  var SET = (/[?&]spinset=(\d{3,4})(&|$)/.exec(Q) || [])[1] || '';
  var SHARP = { '1350': ['pro-glacier'] };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var mod = function (i, n) { return ((i % n) + n) % n; };
  var now = function () { return window.performance.now(); };

  var DPR_MAX = 3;
  var POOL = 6;          /* טעינה ופענוח של הצבע שעל המסך */
  var BG_POOL = 4;       /* הורדה דחוסה של צבע אחר */
  var NUDGE = 10;        /* 10 זוויות = 30 מעלות לכל צד */
  var NUDGE_MS = 2600;

  function saveData() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(String(c.effectiveType || ''))));
  }

  function boot(root) {
    if (!root || root.dataset.tychSpinReady === '1') return;
    var model = root.dataset.tychSpin;
    if (!model) return;
    var frame = root.querySelector('.tych__frame');
    var cv = root.querySelector('[data-tych-spincv]');
    if (!frame || !cv) return;
    root.dataset.tychSpinReady = '1';

    var ctx = cv.getContext('2d');
    var N = Number(root.dataset.tychSpinframes) || 120;
    var STEP = Number(root.dataset.tychSpinstep) || 15;
    var ZOOM = Number(root.dataset.tychSpinzoom) || 1;
    var raw = String(root.dataset.tychSpinbase || '');
    var base = raw.split('ty-spin3-')[0];
    var ver = raw.split('?')[1] || '';
    var dots = [].slice.call(root.querySelectorAll('[data-tych-dot]'));
    var navs = [].slice.call(root.querySelectorAll('[data-tych-nav]'));
    var sharp = function (c) { return !!(SET && SHARP[SET] && SHARP[SET].indexOf(model + '-' + c) >= 0); };
    var url = function (c, i) { return base + 'ty-spin3-' + model + (sharp(c) ? SET : '') + '-' + c + '-f' + pad(i) + '.webp' + (ver ? '?' + ver : ''); };

    var map = {};
    String(root.dataset.tychSpinmap || '').split(',').forEach(function (pair) {
      var kv = pair.split(':');
      if (kv.length === 2) map[kv[0].trim()] = kv[1].trim();
    });

    /* ── מצב ──────────────────────────────────────────────────────────── */
    var sets = {};          /* גימור ⟵ { c, slots, ready, q, live, dead, t0, tReady } */
    var blobs = {};         /* גימור ⟵ [Blob]. דחוס בלבד, מההורדה ברקע */
    var drafts = {};        /* גימור ⟵ { im, ok }. הטיוטה של ?spindraft=1 */
    var color = null, pending = null, wipe = null;
    /* ty-autospin >>> 05.10.2026: זווית פתיחה וסיבוב אוטומטי, רק כשהשורש מבקש (דף המוצר של iPhone 18) */
    var AUTO = Number(root.dataset.tychAutospin) || 0;
    var pos = mod(Number(root.dataset.tychSpinstart) || 0, N), anim = null, nudge = null, drag = null, vel = 0, raf = 0;
    /* <<< ty-autospin */
    var W = 0, H = 0, dw = 0, dh = 0, dx0 = 0, dy0 = 0, dens = 1;
    var shownIdx = -1, shownIm = null, drawnIdx = -1;
    /* `loaded`: מותר לטעון את כל הזוויות ולנדנד. `pageLoaded`: אירוע load של הדף,
       והוא לבדו פותח את הורדת הצבעים ברקע. בלי ?spinearly=1 שניהם נדלקים יחד. */
    var started = false, loaded = document.readyState === 'complete', pageLoaded = loaded, full = false;
    var touchedOnce = false, nudgeState = 'wait', nudgeT0 = 0;
    var lastMoveTs = 0;

    var stat = { paints: 0, draftPaints: 0, stale: 0, maxDraws: 0, draws: [], lat: [], decodes: [] };
    var bg = { on: !NOBG && !saveData(), started: 0, finished: 0, stopped: false, color: null, live: 0, todo: [], ctrl: null,
      done: {}, inflight: {}, bytes: 0, reqs: 0, fail: 0 };

    var state = root.__tychSpin = {
      version: 3, frames: N,
      get paints() { return stat.paints; },
      get pos() { return pos; },
      get frame() { return mod(Math.round(pos), N); },
      get drawn() { return drawnIdx; },
      /* כמה זוויות המסך מאחורי מה שהאצבע ביקשה. 0 אחרי פריים. */
      get lag() { return drawnIdx < 0 ? 0 : Math.min(Math.abs(drawnIdx - mod(Math.round(pos), N)), N - Math.abs(drawnIdx - mod(Math.round(pos), N))); },
      get sinceMove() { return drag && drag.lock ? now() - drag.lt : -1; },
      get color() { return color; },
      get readyNow() { return sets[color] ? sets[color].ready : 0; },
      get t0() { return sets[color] ? sets[color].t0 : 0; },
      get tReady() { return sets[color] ? sets[color].tReady : 0; },
      get decoded() { return Object.keys(sets).map(function (k) { return k + ':' + sets[k].ready; }); },
      get density() { return dens; },
      get canvas() { return W + 'x' + H; },
      get stale() { return stat.stale; },
      get maxDraws() { return stat.maxDraws; },
      get nudge() { return nudgeState; },
      get wiping() { return !!wipe; },
      get pending() { return pending ? pending.key : null; },
      get loaded() { return loaded; },
      get pageLoaded() { return pageLoaded; },
      get draft() { var d = drafts[color]; return { on: DRAFT, ok: !!(d && d.ok), ms: d && d.t ? Math.round(d.t - d.t0) : 0, paints: stat.draftPaints }; },
      get fold() {
        var s = foldSets[color + '|u'], o = foldSets[color + '|r'];
        return { on: fold.on, open: fold.open, pos: Math.round(fold.pos), frames: FOLD_N, ready: s ? s.ready : 0, moving: !!fold.anim,
          openFrame: fold.open && !fold.anim ? mod(Math.round(pos), N) : -1, openReady: o ? o.ready : 0,
          parked: !!(sets[color] && sets[color].parked), closedReady: sets[color] ? sets[color].ready : 0, zoom: +openZ.toFixed(3), upscale: +(openZ * dh / 1000).toFixed(3) };
      },
      get early() { return EARLY; },
      get set() { return sharp(color) ? SET : ''; },
      /* ty-duo-intro >>> */ get intro() { return intro.state + ':' + intro.step + ':' + (INTRO || '-'); }, /* <<< ty-duo-intro */
      get bg() { return { on: bg.on, started: bg.started, finished: bg.finished, done: Object.keys(bg.done), bytes: bg.bytes, reqs: bg.reqs, fail: bg.fail, stopped: bg.stopped, blobs: Object.keys(blobs).map(function (k) { return k + ':' + blobs[k].filter(Boolean).length; }) }; }
    };

    /* ── סדרי טעינה ──────────────────────────────────────────────────── */
    function ring(start, radius) {
      var out = [mod(start, N)];
      for (var d = 1; d <= radius; d++) { out.push(mod(start + d, N)); out.push(mod(start - d, N)); }
      return out;
    }
    /* שלד גס ואז מילוי: עם החלפה פשוטה, כל זווית חסרה מוצגת כשכנה הקרובה */
    function spread(start) {
      var seen = {}, out = [];
      [30, 15, 8, 4, 2, 1].forEach(function (gap) {
        for (var d = 0; d < N; d += gap) {
          [start + d, start - d].forEach(function (k) { var i = mod(k, N); if (!seen[i]) { seen[i] = 1; out.push(i); } });
        }
      });
      return out;
    }

    /* ── טעינה ופענוח של צבע ────────────────────────────────────────── */
    function makeSet(c) {
      var s = { c: c, slots: [], ready: 0, q: [], live: 0, dead: false, t0: now(), tReady: 0 };
      for (var i = 0; i < N; i++) s.slots.push({ i: i, im: null, ok: false, busy: false, fail: 0, obj: '' });
      return s;
    }
    function want(s, list) { s.q = list.concat(s.q); pump(s); }
    function pump(s) {
      while (!s.dead && !s.parked && s.live < POOL && s.q.length) {
        var slot = s.slots[s.q.shift()];
        if (slot.ok || slot.busy || slot.fail > 1) continue;
        startSlot(s, slot);
      }
    }
    function startSlot(s, slot) {
      slot.busy = true;
      s.live += 1;
      var b = blobs[s.c] && blobs[s.c][slot.i];
      var im = new Image();
      im.decoding = 'async';
      if (!color && 'fetchPriority' in im) im.fetchPriority = 'high';
      if (b && window.URL && URL.createObjectURL) slot.obj = URL.createObjectURL(b);
      var t = now(), finished = false;
      var fin = function (ok) {
        if (finished) return;
        finished = true;
        s.live -= 1;
        slot.busy = false;
        if (s.dead || s.parked) { im.src = ''; freeObj(slot); return; }
        if (ok) {
          slot.im = im;
          slot.ok = true;
          s.ready += 1;
          if (DEBUG) stat.decodes.push(now() - t);
          if (s.ready === N && !s.tReady) s.tReady = now();
          onSlot(s, slot);
        } else {
          freeObj(slot);
          if (b && blobs[s.c]) blobs[s.c][slot.i] = null;   /* ה-blob פגום: חזרה לרשת */
          slot.fail += 1;
          if (slot.fail < 2) s.q.push(slot.i);
        }
        pump(s);
      };
      im.src = slot.obj || url(s.c, slot.i);
      if (im.decode) im.decode().then(function () { fin(true); }, function () { fin(im.complete && im.naturalWidth > 0); });
      else { im.onload = function () { fin(true); }; im.onerror = function () { fin(false); }; }
    }
    function freeObj(slot) {
      if (slot.obj && window.URL && URL.revokeObjectURL) URL.revokeObjectURL(slot.obj);
      slot.obj = '';
    }
    function freeColor(c) {
      var s = sets[c];
      if (!s || c === color || (pending && pending.key === c)) return;
      freeDraft(c);
      s.dead = true;
      s.q = [];
      s.slots.forEach(function (sl) { if (sl.im) sl.im.src = ''; sl.im = null; freeObj(sl); });
      delete sets[c];
    }

    function onSlot(s, slot) {
      if (pending && pending.key === s.c && slot.i === pending.i) { commit(); return; }
      if (s.c === color || (wipe && wipe.from === s.c)) {
        req();
        if (nudgeState === 'wait') tryNudge();
      }
      if (s.c === color && s.ready === N) { freeDraft(s.c); foldLoad(s.c); bgStart(); bgResume(); }
    }

    /* כל הזוויות של הצבע שעל המסך: אחרי load, או כשהלקוח כבר נגע */
    function loadAll() {
      if (full || !color || !sets[color] || sets[color].parked) return;
      full = true;
      var i = mod(Math.round(pos), N);
      want(sets[color], ring(i, NUDGE).concat(spread(i)));
    }

    /* ── ציור ──────────────────────────────────────────────────────── */
    function measure() {
      var r = cv.getBoundingClientRect();
      var d = Math.min(DPR_MAX, window.devicePixelRatio || 1);
      var w = Math.round(r.width * d), h = Math.round(r.height * d);
      if (!w || !h) return false;
      if (w === W && h === H) return false;
      W = w; H = h; dens = d;
      cv.width = W; cv.height = H;
      var sc = Math.min(W / 640, H / 1000) * ZOOM;
      dw = Math.round(640 * sc); dh = Math.round(1000 * sc);
      dx0 = Math.round((W - dw) / 2); dy0 = Math.round((H - dh) / 2);
      /* הזום של ה-Duo הפתוח: ממלא את הקנבס עם 3% שוליים, בכל זווית, ולא מגדיל מעבר ל-OPEN_UPSCALE */
      var sz = dh / 1000;
      openZ = Math.max(1, Math.min((W * 0.47) / (OPEN_HALF[0] * sz), (H * 0.47) / (OPEN_HALF[1] * sz), OPEN_UPSCALE / sz));
      shownIdx = -1; shownIm = null;
      return true;
    }
    function pick(s, i) {
      if (!s) return null;
      if (s.slots[i].ok) return s.slots[i];
      for (var d = 1, m = Math.ceil(N / 8); d <= m; d++) {
        var a = s.slots[mod(i - d, N)], b = s.slots[mod(i + d, N)];
        if (a.ok) return a;
        if (b.ok) return b;
      }
      return null;
    }
    /* 🔴 22.09.2026: הפתיחה והסיבוב הפתוח צולמו **באותה מצלמה של הסיבוב הסגור**,
          640 על 1000 באותה מסגרת בדיוק. `u00` זהה לזווית 0 של הסיבוב הסגור ו-`u59`
          זהה לזווית 0 של הסיבוב הפתוח, בהפרש אפס (נמדד במשרד על הקבצים עצמם).
       ⟹ כל פריים מצויר במלבן של פריים הסיבוב, בלי שום מתיחה ובלי היסט. המרחק
          והמרכוז אפויים בתמונות. `FOLD_K`/`FOLD_OX`/`FOLD_OY` של 20.09 נמחקו.
          הדוח: docs/cs-hero-spin-2026-09-16/OFFICE-RENDER-DUO-OPEN-REPORT.md (shopify-agent). */
    function paint() {
      if (!W || !color) return;
      if (fold.on && (fold.open || fold.anim)) {
        var fs = null, fk = 0;
        if (fold.anim) {
          var fi = Math.max(0, Math.min(FOLD_N - 1, Math.round(fold.pos)));
          fs = foldPick('u', fi); fk = fs ? -1 - fs.i : 0;
        } else {
          /* פתוח ועומד: הסיבוב הפתוח. זווית שעוד לא ירדה ⟵ השכנה הקרובה, ובזווית 0 גם
             הפריים האחרון של הפתיחה, שהוא אותה תמונה בדיוק */
          var oi = mod(Math.round(pos), N);
          fs = foldPick('r', oi); fk = fs ? -1000 - fs.i : 0;
          if (!fs || (fs.i !== oi && oi === 0)) { var last = foldPick('u', FOLD_N - 1); if (last && last.i === FOLD_N - 1) { fs = last; fk = -FOLD_N; } }
        }
        if (fs) {
          if (!fold.anim && shownIdx === fk && shownIm === fs.im) return;   /* באמצע פתיחה הזום זז גם בלי פריים חדש */
          var tf = now(), z = foldZoom();
          ctx.clearRect(0, 0, W, H);
          if (z === 1) ctx.drawImage(fs.im, dx0, dy0, dw, dh);               /* בדיוק כמו הסיבוב הסגור */
          else { var zw = Math.round(dw * z), zh = Math.round(dh * z); ctx.drawImage(fs.im, Math.round((W - zw) / 2), Math.round((H - zh) / 2), zw, zh); }
          if (DEBUG) stat.draws.push(now() - tf);
          shownIdx = fk; shownIm = fs.im; stat.paints += 1;
          spun();
        }
        return;
      }
      var i = mod(Math.round(pos), N);
      var hit = pick(sets[color], i);
      if (wipe) {
        var t0 = now(), n = 0;
        ctx.clearRect(0, 0, W, H);
        var old = pick(sets[wipe.from], i);
        if (old) { ctx.drawImage(old.im, dx0, dy0, dw, dh); n++; }
        if (hit) {
          ctx.save();
          ctx.beginPath();
          ctx.arc(wipe.x, wipe.y, wipe.r, 0, Math.PI * 2);
          ctx.clip();
          ctx.clearRect(0, 0, W, H);
          ctx.drawImage(hit.im, dx0, dy0, dw, dh);
          ctx.restore();
          n++;
        }
        if (DEBUG) stat.draws.push(now() - t0);
        shownIdx = -1; shownIm = null;
        if (n) { stat.paints += 1; drawnIdx = (hit || old).i; spun(); }
        return;
      }
      /* טיוטה: רק כשאין זווית מלאה מדויקת, ורק כשהטיוטה קרובה יותר לזווית המבוקשת */
      var dr = drafts[color];
      if (dr && dr.ok && !(hit && hit.i === i)) {
        var k = mod(Math.round((i * DRAFT_N) / N), DRAFT_N);
        var kf = (k * N) / DRAFT_N;
        var dd = Math.min(Math.abs(kf - i), N - Math.abs(kf - i));
        var hd = hit ? Math.min(Math.abs(hit.i - i), N - Math.abs(hit.i - i)) : Infinity;
        if (dd < hd) {
          if (i === shownIdx && shownIm === dr.im) return;
          var td = now();
          ctx.clearRect(0, 0, W, H);
          ctx.drawImage(dr.im, (k % DRAFT_COLS) * DRAFT_W, Math.floor(k / DRAFT_COLS) * DRAFT_H, DRAFT_W, DRAFT_H, dx0, dy0, dw, dh);
          if (DEBUG) {
            stat.draws.push(now() - td);
            if (lastMoveTs) { stat.lat.push(now() - lastMoveTs); lastMoveTs = 0; }
          }
          shownIdx = i; shownIm = dr.im; drawnIdx = kf;
          stat.paints += 1; stat.draftPaints += 1;
          spun();
          return;
        }
      }
      if (!hit || (i === shownIdx && hit.im === shownIm)) return;
      var t = now();
      ctx.clearRect(0, 0, W, H);
      ctx.drawImage(hit.im, dx0, dy0, dw, dh);
      if (stat.maxDraws < 1) stat.maxDraws = 1;
      if (DEBUG) {
        stat.draws.push(now() - t);
        if (lastMoveTs) { stat.lat.push(now() - lastMoveTs); lastMoveTs = 0; }
      }
      if (hit.i !== i) stat.stale += 1;
      shownIdx = i; shownIm = hit.im; drawnIdx = hit.i;
      stat.paints += 1;
      spun();
    }
    function spun() { if (!root.classList.contains('is-spun')) { root.classList.add('is-spun'); armEarly(); } }

    /* ?spindraft=1: תמונה אחת קטנה, נטענת ומפוענחת פעם אחת. אין טעם בה לצבע שכבר מוכן כולו. */
    function loadDraft(c) {
      if (!DRAFT || !c || drafts[c]) return;
      if (sets[c] && sets[c].ready >= N) return;
      var d = drafts[c] = { im: new Image(), ok: false, t0: now(), t: 0 };
      d.im.decoding = 'async';
      d.im.src = base + 'ty-spin3-' + model + '-' + c + '-draft.webp' + (ver ? '?' + ver : '');
      var fin = function () {
        if (drafts[c] !== d || d.im.naturalWidth !== DRAFT_COLS * DRAFT_W) return;
        d.ok = true; d.t = now();
        shownIdx = -1;
        req();
      };
      if (d.im.decode) d.im.decode().then(fin, function () {});
      else d.im.onload = fin;
    }
    function freeDraft(c) {
      if (!drafts[c]) return;
      drafts[c].im.src = '';
      delete drafts[c];
    }

    /* ── לולאה אחת: תנועה, ואז ציור, פעם אחת בפריים ────────────────────── */
    var easeOut = function (k) { return 1 - Math.pow(1 - k, 3); };
    var easeInOut = function (k) { return k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2; };
    function tick(t) {
      raf = 0;
      var moving = false;
      if (anim) {
        var k = Math.min(1, (t - anim.t0) / anim.ms);
        pos = anim.from + (anim.to - anim.from) * anim.ease(k);
        if (k >= 1) { pos = anim.to; anim = null; settleAria(); if (fold.wait) { fold.wait = false; foldStart(); } } else moving = true;
      }
      /* ty-autospin >>> סיבוב מלא בקצב קבוע. צעד הזמן חסום ב-50ms: חלון הצ'אט תוקע את הדף, והסיבוב ממשיך מאותה נקודה */
      if (nudge && nudge.full) {
        /* 06.10.2026: זווית שאין מה לצייר בה (לא חדה ולא טיוטה) עוצרת את השעון, ולא מדלגים עליה.
           בלי זה, ברשת איטית הסיבוב «רץ» בלי לצייר, והטלפון נראה עומד. נתפס בצילום. */
        var dt = nudge.last == null ? 0 : Math.min(50, t - nudge.last); nudge.last = t;
        var nx = mod(Math.round(nudge.base + N * Math.min(1, (nudge.el + dt) / nudge.ms)), N), ds = drafts[color];
        if ((sets[color] && sets[color].slots[nx].ok) || (ds && ds.ok)) nudge.el += dt;
        var kq = Math.min(1, nudge.el / nudge.ms);
        pos = nudge.base + N * kq;
        if (kq >= 1) { pos = nudge.base; nudge = null; nudgeState = 'done'; settleAria(); } else moving = true;
      } else
      /* <<< ty-autospin */
      if (nudge) {
        var kn = Math.min(1, (t - nudge.t0) / nudge.ms);
        var ph = 0.5 - 0.5 * Math.cos(Math.PI * kn);                   /* התחלה וסוף רכים */
        pos = nudge.base + nudge.a * Math.sin(2 * Math.PI * ph);
        if (kn >= 1) { pos = nudge.base; nudge = null; nudgeState = 'done'; } else moving = true;
      }
      /* ty-duo-intro >>> */ if (introTick(t)) moving = true; /* <<< ty-duo-intro */
      if (fold.anim) {
        var kf = fold.anim.ms > 0 ? Math.min(1, (t - fold.anim.t0) / fold.anim.ms) : 1;
        var ef = kf < 0.5 ? 4 * kf * kf * kf : 1 - Math.pow(-2 * kf + 2, 3) / 2;   /* רך בשני הקצוות */
        fold.pos = fold.from + (fold.anim.to - fold.from) * ef;
        if (kf >= 1) { fold.pos = fold.anim.to; fold.anim = null; if (fold.open) parkSpin(); else openFree(color); } else moving = true;
      }
      if (wipe) {
        var kw = Math.max(0, Math.min(1, (t - wipe.t0) / wipe.ms)); /* ty-wipe-clamp: הפריים עלול להקדים את הלחיצה */
        wipe.r = wipe.far * easeOut(kw);
        if (kw >= 1) { var from = wipe.from; wipe = null; shownIdx = -1; freeColor(from); } else moving = true;
      }
      paint();
      if (moving) req();
    }
    function req() { if (!raf) raf = window.requestAnimationFrame(tick); }

    var ariaTimer = 0;
    function settleAria() {
      window.clearTimeout(ariaTimer);
      ariaTimer = window.setTimeout(function () {
        cv.setAttribute('aria-valuenow', String(Math.round((mod(Math.round(pos), N) / N) * 360)));
      }, 250);
    }
    function glide(to, ms, ease) { anim = { from: pos, to: to, t0: now(), ms: ms, ease: ease || easeOut }; req(); }
    function settle() { var r = Math.round(pos); if (pos !== r) { pos = r; req(); } settleAria(); }

    /* ── נדנוד פתיחה ────────────────────────────────────────────────────
       🔴 הקשת נקבעת לפי מה שכבר נטען משני הצדדים, ולא נקבעת מראש. עד 3 שניות
          מחכים ל-20 הזוויות. פחות מ-4 לכל צד: אין נדנוד, ולא ננסה שוב. */
    function stopNudge(why) {
      if (nudge) { nudge = null; pos = Math.round(pos); req(); }
      if (nudgeState !== 'done') nudgeState = why || 'stopped';
    }
    function tryNudge() {
      /* ty-duo-nospin >>> n: בלי פתיחה ובלי נדנוד. הזוויות הסגורות נטענות כבר עכשיו, כדי שגרירה ראשונה תהיה חדה */
      if (INTRO === 'n') { intro.state = 'off'; if (nudgeState === 'wait') nudgeState = 'off'; if (seenOnce) loadAll(); return; }
      /* <<< ty-duo-nospin */
      /* ty-duo-intro >>> */ if (INTRO) { introRun(); return; } /* <<< ty-duo-intro */
      if (nudgeState !== 'wait') return;
      if (reduce) { nudgeState = 'reduced'; return; }
      if (touchedOnce) { nudgeState = 'touched'; return; }
      /* ty-autospin >>> 06.10.2026, יובל: «רק את הסיבוב ישר». לא מחכים ל-load ולא ל-120 הזוויות.
         הסיבוב מתחיל ברגע שיש מה לצייר (הטיוטה או הזווית שעל המסך), וכל הזוויות יורדות מיד,
         לפי כיוון הסיבוב. זווית שעוד לא ירדה מצוירת מהטיוטה, ומתחדדת כשהיא מגיעה. */
      if (AUTO) {
        if (!seenOnce) return;
        if (!nudgeT0) nudgeT0 = now();
        if (now() - nudgeT0 > 15000) { nudgeState = 'skipped'; return; }
        if (!sets[color] || drag || anim || wipe || pending || fold.open || fold.anim) { window.setTimeout(tryNudge, 100); return; }
        var s0 = sets[color], b0 = Math.round(pos), dr0 = drafts[color];
        if (!full) { full = true; var fwd = []; for (var q = 0; q < N; q++) fwd.push(mod(b0 + q, N)); want(s0, fwd); }
        if (!(s0.slots[mod(b0, N)].ok || (dr0 && dr0.ok))) { window.setTimeout(tryNudge, 100); return; }
        nudgeState = 'running';
        pos = b0;
        nudge = { full: true, base: b0, el: 0, last: null, ms: AUTO };
        req();
        return;
      }
      /* <<< ty-autospin */
      if (!loaded || !seenOnce || !sets[color] || drag || anim || wipe || pending || fold.open || fold.anim) return;
      if (!nudgeT0) { nudgeT0 = now(); window.setTimeout(tryNudge, 3050); }
      var s = sets[color], b = Math.round(pos);
      var side = function (dir) { var n = 0; for (var d = 1; d <= NUDGE; d++) { if (!s.slots[mod(b + dir * d, N)].ok) break; n = d; } return n; };
      var a = Math.min(side(1), side(-1));
      if (a < NUDGE && now() - nudgeT0 < 3000) return;
      if (a < 4) { nudgeState = 'skipped'; return; }
      nudgeState = 'running';
      pos = b;
      nudge = { base: b, a: a, t0: now(), ms: NUDGE_MS };
      req();
    }

    /* ── ה-Duo: נפתח ונסגר בלחיצה, ומסתובב גם פתוח (22.09.2026) ──────────
       🔴 הכרעת יובל 17.09.2026: «לחיצה אחת עם כפתור פתח/סגור». לחיצה פותחת, לחיצה סוגרת.
       🟢 22.09.2026: **החלקה במצב פתוח מסובבת את המכשיר הפתוח**, ואינה סוגרת עוד.
          הסגירה היא בלחיצה בלבד: קודם הסיבוב חוזר לחזית, ואז המכשיר נסגר.
       📦 שני סטים לכל גימור, 640 על 1000 באותה מסגרת של הסיבוב הסגור:
          `ty-duo-<גימור>-u<NN>.webp` הפתיחה, 60 פריימים · `ty-duo-<גימור>-r<NN>.webp` הסיבוב הפתוח, 120.
          הסטים של 20.09 (`-700-o<NN>`, `-1100-o<NN>`) נשארו בערכה כנתיב חזרה ואינם נטענים.
       🔴 הזיכרון: בזמן שהמכשיר פתוח, הזוויות המפוענחות של הסיבוב הסגור משתחררות
          (`parked`), וחוזרות מהמטמון כשהוא נסגר. אחרת שני סיבובים מפוענחים יחד, כ-600MB.
          בזמן החזרה מוצג הפריים הראשון של הפתיחה, שהוא אותה תמונה כמו הזווית הסגורה. */
    var FOLD_N = Number(root.dataset.tychFoldframes) || 0;
    var foldRaw = String(root.dataset.tychFoldkey || '');
    var foldBase = foldRaw.split('ty-duo-')[0];
    var foldVer = foldRaw.split('?')[1] || '';
    var FOLD_MS = 780;
    var FOLD_HOME_MS = 700;                 /* תקרת ההחזרה לחזית, לפני פתיחה ולפני סגירה */
    /* 🔍 הזום של המכשיר הפתוח. הפריימים נושאים את המצלמה של הסיבוב הסגור, ולכן הפתוח
          קטן בהם (91% מהרוחב ו-41% מהגובה של 640 על 1000). בלי זום הוא נראה זעיר במחשב.
       ⟹ הזום עולה מ-1 בפריים הראשון של הפתיחה (זהה לסיבוב הסגור) עד openZ בסופה, באותה
          עקומה של מרחק המצלמה ברינדור (1 − (1 − k)^1.5), ולכן הגודל הנראה משתנה במגמה אחת.
       📏 OPEN_HALF: חצי המעטפת של כל 120 הזוויות הפתוחות סביב (320, 500), נמדד על הקבצים
          של שני הגימורים: [23, 279, 617, 763] ⟵ 297 לרוחב ו-263 לגובה.
       🔴 OPEN_UPSCALE: תקרת ההגדלה מפיקסל מקור לפיקסל קנבס. בטלפון (צפיפות 3) היא שקובעת,
          כי מעבר לה הפתוח נראה רך. בסט הישן זה נפתר בסט 1100, וכאן יש 640 על 1000 בלבד. */
    var OPEN_HALF = [297, 263], OPEN_UPSCALE = 1.35, openZ = 1;
    function foldZoom() {
      var k = fold.anim ? Math.max(0, Math.min(1, fold.pos / (FOLD_N - 1))) : (fold.open ? 1 : 0);
      return k <= 0 ? 1 : 1 + (openZ - 1) * (1 - Math.pow(1 - k, 1.5));
    }
    var foldSets = {};
    var fold = { on: FOLD_N > 0 && !!foldBase, open: false, pos: 0, anim: null, w: 640, t0: 0, from: 0, wait: false };
    /* u = הפתיחה (FOLD_N פריימים), r = הסיבוב הפתוח (N זוויות, אותו מספור כמו הסיבוב הסגור) */
    var foldUrl = function (c, k, i) { return foldBase + 'ty-duo-' + c + '-' + k + pad(i) + '.webp' + (foldVer ? '?' + foldVer : ''); };

    function foldSet(c, k) {
      var key = c + '|' + k;
      if (!foldSets[key]) {
        var s = { c: c, k: k, n: k === 'r' ? N : FOLD_N, slots: [], ready: 0, live: 0, q: [] };
        for (var i = 0; i < s.n; i++) s.slots.push({ i: i, im: null, ok: false, busy: false, fail: 0 });
        foldSets[key] = s;
      }
      return foldSets[key];
    }
    function foldPump(s) {
      while (s.live < (s.k === 'r' ? POOL : 4) && s.q.length) {
        var slot = s.slots[s.q.shift()];
        if (!slot || slot.ok || slot.busy || slot.fail > 1) continue;
        (function (sl) {
          sl.busy = true; s.live += 1;
          var im = new Image();
          im.decoding = 'async';
          var fin = function (ok) {
            s.live -= 1; sl.busy = false;
            if (foldSets[s.c + '|' + s.k] !== s) { im.src = ''; return; }     /* הסט שוחרר בינתיים */
            if (ok) { sl.im = im; sl.ok = true; s.ready += 1; req(); } else { sl.fail += 1; if (sl.fail < 2) s.q.push(sl.i); }
            foldPump(s);
          };
          im.src = foldUrl(s.c, s.k, sl.i);
          if (im.decode) im.decode().then(function () { fin(true); }, function () { fin(im.complete && im.naturalWidth > 0); });
          else { im.onload = function () { fin(true); }; im.onerror = function () { fin(false); }; }
        }(slot));
      }
    }
    /** הפתיחה: קודם שלד גס, ואז המילוי. כך יש אנימציה מיד. */
    function foldLoad(c) {
      if (!fold.on || !c || !W) return;
      var s = foldSet(c, 'u'), order = [];
      for (var gap = 15; gap >= 1; gap = gap === 1 ? 0 : Math.max(1, Math.floor(gap / 2))) {
        for (var i = 0; i < FOLD_N; i += gap) if (order.indexOf(i) < 0) order.push(i);
        if (!gap) break;
      }
      if (order.indexOf(FOLD_N - 1) < 0) order.push(FOLD_N - 1);
      s.q = order;
      foldPump(s);
    }
    /** הסיבוב הפתוח נטען רק כשהלקוח פותח, כדי לא להוסיף משקל לכל מי שרק מסובב סגור.
        סדר: הזוויות הקרובות לחזית, ואז שלד ומילוי כמו בסיבוב הסגור. */
    function openLoad(c) {
      if (!fold.on || !c || !W) return;
      var s = foldSet(c, 'r'), i = fold.open ? mod(Math.round(pos), N) : 0;   /* נפתח תמיד בחזית */
      s.q = ring(i, NUDGE).concat(spread(i));
      foldPump(s);
    }
    function openFree(c) {
      var s = foldSets[c + '|r'];
      if (!s) return;
      s.slots.forEach(function (sl) { if (sl.im) sl.im.src = ''; sl.im = null; });
      delete foldSets[c + '|r'];
    }
    function foldPick(k, i) {
      var s = foldSets[color + '|' + k];
      if (!s) return null;
      if (s.slots[i] && s.slots[i].ok) return s.slots[i];
      for (var d = 1; d < s.n; d++) {
        var a = s.slots[k === 'r' ? mod(i - d, s.n) : i - d], b = s.slots[k === 'r' ? mod(i + d, s.n) : i + d];
        if (a && a.ok) return a;
        if (b && b.ok) return b;
        if (k === 'r' && d >= s.n / 8) break;             /* זווית רחוקה מדי אינה מחליפה */
      }
      return null;
    }
    /* הסיבוב הסגור בזמן שהמכשיר פתוח: הזוויות המפוענחות משתחררות, והטעינה נעצרת */
    function parkSpin() {
      var s = sets[color];
      if (!s || s.parked) return;
      s.parked = true;
      s.q = [];
      s.slots.forEach(function (sl) { if (sl.ok) { sl.im.src = ''; sl.im = null; sl.ok = false; freeObj(sl); } });
      s.ready = 0; s.tReady = 0;
      full = false;
    }
    function unparkSpin() {
      Object.keys(sets).forEach(function (c) { if (sets[c].parked) { sets[c].parked = false; } });
      if (loaded || touchedOnce) loadAll();
      else if (sets[color]) want(sets[color], [mod(Math.round(pos), N)]);
    }
    function foldStart() {
      fold.from = fold.pos;
      fold.open = !fold.open;
      if (!fold.open) unparkSpin();                      /* הזוויות הסגורות חוזרות בזמן הסגירה */
      fold.anim = { to: fold.open ? FOLD_N - 1 : 0, t0: now(), ms: reduce ? 0 : FOLD_MS };
      root.classList.toggle('is-duoopen', fold.open);
      /* הרמז נשאר על המסך תמיד (יובל 20.09.2026), ולכן כשהמכשיר פתוח הוא אומר «לסגור».
         כתיבה ל-DOM רק במעבר, לא בכל פריים. */
      var hint = root.querySelector('[data-tych-spinhint]');
      if (hint) for (var hn = hint.firstChild; hn; hn = hn.nextSibling) {
        if (hn.nodeType === 3) hn.nodeValue = hn.nodeValue.replace(fold.open ? 'כדי לפתוח' : 'כדי לסגור', fold.open ? 'כדי לסגור' : 'כדי לפתוח');
      }
      shownIdx = -1; shownIm = null;
      req();
    }
    /** 🔴 הפתיחה מצוירת בזווית אחת בלבד (החזית), ולכן כל לחיצה מחזירה קודם לחזית.
        בפתיחה זה הסיבוב הסגור, ובסגירה זה הסיבוב הפתוח. אותו `pos` משמש את שניהם,
        והיעד הוא הכפולה הקרובה של N, ולכן הדרך תמיד הקצרה. בקשת יובל 20.09.2026. */
    function foldHome() {
      var home = Math.round(pos / N) * N, d = Math.abs(pos - home);
      if (d < 0.5 || reduce) { pos = home; return 0; }
      var ms = Math.min(FOLD_HOME_MS, 120 + d * 11);
      glide(home, ms, easeInOut);
      return ms;
    }
    function foldToggle() {
      if (!fold.on || fold.anim) return;                /* באמצע פתיחה או סגירה: מתעלמים */
      foldLoad(color);
      if (!fold.open) openLoad(color);
      anim = null; nudge = null; vel = 0;
      if (foldHome()) { fold.wait = true; return; }
      foldStart();
    }

    /* ty-duo-intro >>> 22.10.2026, יובל: «יתחיל סגור, ייפתח, ייתן חצי סיבוב, ייסגר ויחזור להתחלה».
       נדלק רק עם data-tych-duointro (הסניפט מוסיף רק ל-Duo). ?duointro=a|b|c|off גובר, לבדיקה. */
    var INTRO = (function () {
      var m = /[?&]duointro=([a-z]+)/.exec(window.location.search);
      var v = m ? m[1] : String(root.dataset.tychDuointro || '');
      return /^[abcn]$/.test(v) ? v : '';   /* ty-duo-nospin: n נוסף */
    }());
    var INTRO_TURN_MS = 2200, INTRO_PAUSE_MS = 500, INTRO_WAIT_MS = 12000;
    var intro = { state: INTRO ? 'wait' : 'off', step: 0, t0: 0, plan: [] }, introTurn = null;
    function introPlan() {
      var H = N / 2;
      if (INTRO === 'a') return ['open', [0, N, INTRO_TURN_MS * 2], 'close'];
      if (INTRO === 'b') return ['open', [0, H, INTRO_TURN_MS], [H, 0, INTRO_TURN_MS], 'close'];
      return ['open', [0, H, INTRO_TURN_MS], ['pause', INTRO_PAUSE_MS], [H, N, INTRO_TURN_MS], 'close'];
    }
    function introStop(why) {
      if (intro.state === 'wait' || intro.state === 'running') intro.state = why || 'stopped';
      introTurn = null;
    }
    function introRun() {
      if (intro.state !== 'wait') return;
      nudgeState = 'intro';
      if (reduce) { intro.state = 'reduced'; return; }
      if (touchedOnce) { intro.state = 'touched'; return; }
      if (!fold.on) { intro.state = 'nofold'; return; }
      if (!seenOnce || !sets[color] || !W) { window.setTimeout(introRun, 100); return; }
      if (!intro.t0) { intro.t0 = now(); foldLoad(color); openLoad(color); }
      if (now() - intro.t0 > INTRO_WAIT_MS) { intro.state = 'skipped'; return; }
      var u = foldSets[color + '|u'], r = foldSets[color + '|r'];
      if (drag || anim || wipe || pending || fold.anim || !u || u.ready < FOLD_N || !r || !r.slots[0].ok) { window.setTimeout(introRun, 100); return; }
      intro.state = 'running'; intro.plan = introPlan(); intro.step = 0;
      pos = Math.round(pos / N) * N;
      introNext();
    }
    function introNext() {
      if (intro.state !== 'running') return;
      if (touchedOnce) { introStop('touched'); return; }
      if (anim || fold.anim || fold.wait) { window.setTimeout(introNext, 40); return; }
      var s = intro.plan[intro.step++];
      if (s === undefined) { pos = mod(Math.round(pos), N); intro.state = 'done'; settleAria(); req(); return; }
      if (s === 'open') { if (!fold.open) foldToggle(); window.setTimeout(introNext, 40); return; }
      if (s === 'close') { if (fold.open) foldToggle(); window.setTimeout(introNext, 40); return; }
      if (s[0] === 'pause') { window.setTimeout(introNext, s[1]); return; }
      introTurn = { from: s[0], to: s[1], ms: reduce ? 0 : s[2], el: 0, last: null };
      pos = s[0];
      req();
    }
    /** נקרא מ-tick. מחזיר true כשעדיין זז. */
    function introTick(t) {
      if (!introTurn) return false;
      if (touchedOnce || intro.state !== 'running') { introTurn = null; return false; }
      var it = introTurn, dt = it.last == null ? 0 : Math.min(50, t - it.last); it.last = t;
      var k1 = it.ms > 0 ? Math.min(1, (it.el + dt) / it.ms) : 1;
      var nx = mod(Math.round(it.from + (it.to - it.from) * easeInOut(k1)), N), rs = foldSets[color + '|r'];
      if (rs && rs.slots[nx] && rs.slots[nx].ok) it.el += dt;       /* זווית שעוד לא ירדה עוצרת את השעון */
      var k = it.ms > 0 ? Math.min(1, it.el / it.ms) : 1;
      pos = it.from + (it.to - it.from) * easeInOut(k);
      if (k >= 1) { pos = it.to; introTurn = null; window.setTimeout(introNext, 0); return false; }
      return true;
    }
    /* <<< ty-duo-intro */
    /* ── החלקה ─────────────────────────────────────────────────────────── */
    var perPx = function () { return N / Math.max(600, window.innerWidth * 1.2); };
    function touched() {
      touchedOnce = true;
      /* ty-duo-intro >>> */ introStop('touched'); /* <<< ty-duo-intro */
      stopNudge('touched');
      loadAll();
      if (!root.classList.contains('is-spintouched')) root.classList.add('is-spintouched');
    }

    cv.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.stopPropagation();
      touchedOnce = true;
      stopNudge('touched');
      loadAll();
      anim = null;
      drag = { x: e.clientX, y: e.clientY, p: pos, lock: false, lx: e.clientX, lt: e.timeStamp, id: e.pointerId, t0: e.timeStamp };
      vel = 0;
    });
    cv.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      e.stopPropagation();
      var ddx = e.clientX - drag.x, ddy = e.clientY - drag.y;
      if (!drag.lock) {
        if (Math.abs(ddx) < 6) return;
        if (Math.abs(ddx) < Math.abs(ddy) * 1.2) { drag = null; return; }
        /* 🟢 22.09.2026: כשהמכשיר פתוח, החלקה מסובבת את המכשיר הפתוח. באמצע פתיחה או סגירה היא ממתינה. */
        if (fold.on && fold.anim) { drag = null; return; }
        drag.lock = true;
        root.classList.add('is-spindrag');
        touched();
        try { cv.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (e.cancelable) e.preventDefault();
      pos = drag.p + ddx * perPx();
      var dt = e.timeStamp - drag.lt;
      if (dt > 0) vel = 0.7 * vel + 0.3 * (((e.clientX - drag.lx) * perPx()) / dt) * 16.667;
      drag.lx = e.clientX;
      drag.lt = e.timeStamp;
      if (DEBUG) lastMoveTs = now();
      req();
    });
    function release(e) {
      if (!drag) return;
      var was = drag.lock;
      /* נגיעה קצרה בלי גרירה = לחיצה, והיא פותחת או סוגרת את ה-Duo */
      if (fold.on && !was && e && e.timeStamp - drag.t0 < 500 && Math.abs(e.clientX - drag.x) < 6 && Math.abs(e.clientY - drag.y) < 6) {
        drag = null;
        e.stopPropagation();
        foldToggle();
        return;
      }
      if (e) { e.stopPropagation(); if (e.timeStamp - drag.lt > 150) vel = 0; }
      drag = null;
      root.classList.remove('is-spindrag');
      /* התנופה היא גלישה אחת אל הזווית השלמה שהיא הייתה נוחתת לידה */
      if (was && !reduce && Math.abs(vel) > 0.05) {
        var land = Math.round(pos + (vel * 0.93) / 0.07);
        var dist = Math.abs(land - pos);
        if (dist < 0.002) settle();
        else glide(land, Math.max(260, Math.min(1100, (50 * dist) / Math.abs(vel))));
      } else settle();
    }
    cv.addEventListener('pointerup', release);
    cv.addEventListener('pointercancel', function () { release(null); });

    var wheelEnd = 0;
    cv.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      if (fold.on && fold.anim) return;
      anim = null;
      touched();
      pos += e.deltaX * perPx() * 0.6;
      req();
      window.clearTimeout(wheelEnd);
      wheelEnd = window.setTimeout(settle, 140);
    }, { passive: false });

    cv.addEventListener('keydown', function (e) {
      /* מקלדת: רווח או Enter פותחים וסוגרים, בדיוק כמו לחיצה */
      if (fold.on && (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar')) { e.preventDefault(); foldToggle(); return; }
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      if (fold.on && fold.anim) return;
      turn(e.key === 'ArrowRight' ? -1 : 1);
    });

    /* «הקודם» מימין הוא כמו גרירה ימינה */
    function turn(navDir) {
      touched();
      var to = Math.round(pos) - navDir * STEP;
      if (reduce) { pos = to; req(); settleAria(); } else glide(to, 420, easeInOut);
    }
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var nav = t.closest('[data-tych-nav]');
      if (!nav) return;
      e.stopPropagation();
      e.preventDefault();
      turn(Number(nav.dataset.tychNav));
    }, true);

    function unhide() { navs.forEach(function (b) { if (b.hidden) b.hidden = false; }); }
    unhide();
    if (window.MutationObserver && navs.length) {
      var mo = new MutationObserver(unhide);
      navs.forEach(function (b) { mo.observe(b, { attributes: true, attributeFilter: ['hidden'] }); });
    }

    /* ── גימור ─────────────────────────────────────────────────────────── */
    function liveName() {
      var d = root.querySelector('[data-tych-dot][aria-pressed="true"]') || root.querySelector('[data-tych-dot].is-on');
      return d ? d.getAttribute('data-tych-dot') : null;
    }
    function pourMs() {
      var q = /[?&]pour=(\d{3,4})/.exec(Q);
      if (q) return Number(q[1]);
      var v = parseInt(window.getComputedStyle(root).getPropertyValue('--tych-pour'), 10);
      return v > 0 ? v : 1400;
    }
    function dotXY(name) {
      var hit = dots.filter(function (d) { return d.dataset.tychDot === name; })[0];
      var r = cv.getBoundingClientRect();
      var d = W / (r.width || 1);
      if (!hit || !r.width) return { x: W / 2, y: H, far: Math.max(W, H) * 1.3 };
      var dr = hit.getBoundingClientRect();
      var x = (dr.left + dr.width / 2 - r.left) * d;
      var y = (dr.top + dr.height / 2 - r.top) * d;
      return { x: x, y: y, far: Math.max(Math.hypot(x, y), Math.hypot(W - x, y), Math.hypot(x, H - y), Math.hypot(W - x, H - y)) };
    }
    function setColor(name, animate) {
      var key = (name && map[name]) || root.dataset.tychSpindefault;
      if (!key || key === color || (pending && pending.key === key)) return;
      if (color) { touchedOnce = true; stopNudge('touched'); }
      if (pending && pending.key !== color) { var drop = pending.key; pending = null; freeColor(drop); }
      var i = mod(Math.round(pos), N);
      var s = sets[key] || (sets[key] = makeSet(key));
      pending = { key: key, name: name, animate: animate, i: i };
      /* טיוטה לצבע שעוד לא ירד ברקע. בצבע הראשון היא יוצאת כאן, מיד כשהקוד מתחיל:
         אחרי שהטלפון צויר זה נמדד מאוחר מדי (4.3 שנ׳ ב-4G, רק 0.7 לפני הזוויות המלאות). */
      if (!(blobs[key] && blobs[key].filter(Boolean).length === N)) loadDraft(key);
      /* הזווית הנוכחית קודם, אחריה השכנות, ואז השאר. לפני load: רק הזווית שרואים */
      want(s, full || color ? [i].concat(ring(i, 15).slice(1), spread(i)) : [i]);
      if (!color) full = false;
      if (s.slots[i].ok) commit();
    }
    function commit() {
      var p = pending;
      if (!p) return;
      pending = null;
      var from = color;
      /* ty-wipe-back >>> 26.10.2026: חזרה לצבע שבאמצע מעבר. הסט שלו הוא היעד, ואסור לשחרר אותו.
         בלי זה המנוע עבר לצבע בלי תמונות, והמסך נשאר על הצבע הקודם או ריק. */
      if (wipe) { var w = wipe.from; wipe = null; if (w !== p.key) freeColor(w); }
      /* <<< ty-wipe-back */
      color = p.key;
      if (root.dataset.tychSpincolor !== color) root.dataset.tychSpincolor = color;
      shownIdx = -1; shownIm = null;
      if (from && p.animate && !reduce) {
        var g = dotXY(p.name);
        wipe = { from: from, x: g.x, y: g.y, r: 0, far: g.far, t0: now(), ms: pourMs() };
      } else if (from) {
        freeColor(from);
      }
      if (from) full = true;
      /* גימור שהוחלף כשה-Duo פתוח: הסטים של הגימור החדש, והסגור שלו מחכה בצד כמו הקודם */
      if (fold.on && from) {
        delete foldSets[from + '|u']; openFree(from);
        if (fold.open || fold.anim) { foldLoad(color); openLoad(color); }
        if (fold.open && !fold.anim) parkSpin();
      }
      if (loaded && !from) loadAll();
      bgResume();
      tryNudge();
      req();
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        if (!started) return;
        window.setTimeout(function () { setColor(d.dataset.tychDot, true); }, 0);
      });
    });

    /* ── צבעים אחרים ברקע: דחוסים בלבד ────────────────────────────────── */
    function bgColors() {
      var out = [];
      dots.forEach(function (d) { var k = map[d.dataset.tychDot]; if (k && out.indexOf(k) < 0) out.push(k); });
      return out;
    }
    function bgStart() {
      if (!bg.on || bg.started || bg.stopped || !pageLoaded || !sets[color] || sets[color].ready < N) return;
      bg.started = now();
    }
    /* 🔴 אחד בכל פעם: הצבע שעל המסך מוכן כולו, ורק אז צבע אחר, ורק אחד. */
    function bgResume() {
      if (!bg.on || !bg.started || bg.stopped || document.hidden) return;
      if (!sets[color] || sets[color].ready < N) return;
      if (bg.color && bg.color === color) bgDrop();     /* הלקוח בחר אותו: הוא כבר מפוענח */
      if (!bg.color) {
        var next = bgColors().filter(function (c) { return !bg.done[c] && c !== color; })[0];
        if (!next) { if (!bg.finished) bg.finished = now(); return; }
        bg.color = next;
        blobs[next] = blobs[next] || [];
        bg.todo = [];
        for (var i = 0; i < N; i++) if (!blobs[next][i]) bg.todo.push(i);
      }
      if (!bg.ctrl && window.AbortController) bg.ctrl = new AbortController();
      var c = bg.color;
      while (bg.live < BG_POOL && bg.todo.length) bgOne(c, bg.todo.shift());
      if (!bg.todo.length && !(bg.inflight[c] > 0)) {
        bg.done[c] = true;
        bg.color = null;
        bg.ctrl = null;
        bgResume();
      }
    }
    function bgOne(c, i) {
      bg.live += 1;
      bg.inflight[c] = (bg.inflight[c] || 0) + 1;
      var opts = { headers: { Accept: 'image/webp,image/*;q=0.8' }, credentials: 'same-origin' };
      if (bg.ctrl) opts.signal = bg.ctrl.signal;
      window.fetch(url(c, i), opts)
        .then(function (r) {
          bg.reqs += 1;
          if (!r.ok) throw new Error(String(r.status));
          return r.blob();
        })
        .then(function (b) {
          /* פורמט אחר (PNG) היה מכפיל את המשקל: לא נשמר */
          if (b.type && !/webp/i.test(b.type)) throw new Error('type ' + b.type);
          blobs[c][i] = b;
          bg.bytes += b.size;
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') { if (bg.color === c && bg.todo.indexOf(i) < 0) bg.todo.unshift(i); }
          else bg.fail += 1;
        })
        .then(function () {
          bg.live -= 1;
          bg.inflight[c] -= 1;
          bgResume();
        });
    }
    function bgAbort() { if (bg.ctrl) { try { bg.ctrl.abort(); } catch (err) {} } bg.ctrl = null; }
    function bgDrop() { var c = bg.color; bg.color = null; bg.todo = []; bgAbort(); return c; }
    if (bg.on && window.fetch && window.Blob) {
      /* עוזבים את הדף: עוצרים. לשונית ברקע: מושהה, וממשיך כשחוזרים. */
      window.addEventListener('pagehide', function () { bg.stopped = true; bgAbort(); });
      window.addEventListener('pageshow', function (e) { if (e.persisted && bg.stopped) { bg.stopped = false; bgResume(); } });
      document.addEventListener('visibilitychange', function () { if (document.hidden) bgAbort(); else bgResume(); });
    } else bg.on = false;

    /* ── הפעלה ──────────────────────────────────────────────────────────── */
    var seenOnce = false;
    function start() {
      if (started) return;
      started = true;
      /* 🔴 הקנבס לא צייר תוך 8 שניות ⟹ הדף נשאר על הגלריה הישנה, והחצים חוזרים.
         החצים מוסתרים ב-CSS בדפי סיבוב (יובל 20.09.2026), וזו רשת הביטחון. */
      window.setTimeout(function () {
        if (!root.classList.contains('is-spun')) root.classList.add('is-spinfail');
      }, 8000);
      measure();
      setColor(liveName(), false);
      if (window.ResizeObserver) new ResizeObserver(function () { if (measure()) req(); }).observe(frame);
      else window.addEventListener('resize', function () { if (measure()) req(); });
    }
    function onLoad() {
      loaded = true;
      loadAll();
      tryNudge();
    }
    function onPageLoad() {
      pageLoaded = true;
      onLoad();
      bgStart();
      bgResume();
    }
    if (!pageLoaded) window.addEventListener('load', onPageLoad);
    /* ?spinearly=1: אחרי שהטלפון צויר, ברגע שהדפדפן פנוי (עד 1.5 שניות).
       בספארי אין requestIdleCallback, ולכן 300ms אחרי הציור. */
    var earlyArmed = false;
    function armEarly() {
      if (!EARLY || earlyArmed || loaded) return;
      earlyArmed = true;
      if (window.requestIdleCallback) window.requestIdleCallback(onLoad, { timeout: 1500 });
      else window.setTimeout(onLoad, 300);
    }

    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { near.disconnect(); start(); if (loaded) onLoad(); }
      }, { rootMargin: '150% 0px 150% 0px' });
      near.observe(root);
      var seen = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { seen.disconnect(); start(); seenOnce = true; tryNudge(); }
      }, { threshold: 0.5 });
      seen.observe(frame);
    } else { start(); seenOnce = true; if (loaded) onLoad(); }

    if (DEBUG) debugPanel(root, state, stat, bg);
  }

  /* ── ?spindebug=1: טבלת המדידה של דף הבדיקה, על המסך ───────────────────
     נמדד רק בזמן אינטראקציה (אצבע, חץ, תנופה), והטבלה מתעדכנת כשהתנועה נגמרת. */
  function debugPanel(root, S, stat, bg) {
    var el = document.createElement('div');
    el.setAttribute('dir', 'rtl');
    el.style.cssText = 'position:fixed;inset-inline:8px;bottom:8px;z-index:2147483000;background:rgba(0,0,0,.86);color:#fff;' +
      'font:12px/1.45 system-ui,sans-serif;padding:8px 10px;border-radius:8px;max-height:46vh;overflow:auto;pointer-events:auto';
    document.body.appendChild(el);
    var rows = [], gaps = [], down = false, until = 0, mon = 0, last = 0, t0 = 0, d0 = 0, l0 = 0;
    var r1 = function (x) { return Math.round(x * 10) / 10; };
    var pct = function (a, p) { if (!a.length) return null; var s = a.slice().sort(function (x, y) { return x - y; }); return r1(s[Math.min(s.length - 1, Math.floor(p * (s.length - 1)))]); };
    function tick(t) {
      mon = 0;
      if (last) gaps.push(t - last);
      last = t;
      if (down || performance.now() < until) { mon = requestAnimationFrame(tick); return; }
      var g = gaps; gaps = [];
      last = 0;
      if (g.length < 20) { render(); return; }
      var p50 = pct(g, 0.5), lim = Math.max(12, p50 * 1.5), ok = 0, stalls = 0, max = 0;
      g.forEach(function (x) { if (x <= lim) ok++; if (x > 50) stalls++; if (x > max) max = x; });
      rows.push({ sec: r1((performance.now() - t0) / 1000), onTime: Math.round((ok / g.length) * 100), stalls: stalls, max: Math.round(max),
        draw: pct(stat.draws.slice(d0), 0.95), lat: pct(stat.lat.slice(l0), 0.95), hz: p50 ? Math.round(1000 / p50) : null });
      render();
    }
    function begin() { if (!mon) { t0 = performance.now(); d0 = stat.draws.length; l0 = stat.lat.length; mon = requestAnimationFrame(tick); } }
    root.addEventListener('pointerdown', function () { down = true; begin(); }, true);
    window.addEventListener('pointerup', function () { down = false; until = performance.now() + 1200; }, true);
    window.addEventListener('pointercancel', function () { down = false; until = performance.now() + 1200; }, true);
    function render() {
      var mb = function (b) { return (b / 1048576).toFixed(1); };
      var b = S.bg;
      var dec = pct(stat.decodes, 0.95);
      var head = 'צפיפות ' + (window.devicePixelRatio || 1) + ' (ציור ' + S.density + ') · קנבס ' + S.canvas +
        ' · מוכנות ' + S.readyNow + '/' + S.frames + (S.tReady && S.t0 ? ' ב-' + r1((S.tReady - S.t0) / 1000) + ' שנ׳' : '') +
        ' · פענוח p95 ' + (dec === null ? '·' : dec + 'ms') + ' · נדנוד ' + S.nudge +
        '<br>ברקע: ' + (b.on ? (b.finished ? 'הסתיים' : b.started ? 'רץ' : 'ממתין') + ' · ' + b.done.length + ' צבעים · ' + mb(b.bytes) + 'MB · ' + b.reqs + ' בקשות' + (b.fail ? ' · ' + b.fail + ' נכשלו' : '') : 'כבוי') +
        ' · מפוענח ' + S.decoded.join(' ');
      var tbl = rows.length ? '<table style="border-collapse:collapse;margin-top:6px;width:100%"><tr style="opacity:.7"><th>#</th><th>בזמן</th><th>עצירות</th><th>מקס׳ ms</th><th>ציור p95</th><th>אצבע⟵מסך p95</th><th>Hz</th><th>שנ׳</th></tr>' +
        rows.map(function (r, k) { return '<tr style="text-align:center"><td>' + (k + 1) + '</td><td>' + r.onTime + '%</td><td>' + r.stalls + '</td><td>' + r.max + '</td><td>' + (r.draw === null ? '·' : r.draw) + '</td><td>' + (r.lat === null ? '·' : r.lat) + '</td><td>' + (r.hz || '·') + '</td><td>' + r.sec + '</td></tr>'; }).join('') + '</table>'
        : '<div style="opacity:.7;margin-top:4px">סובבו את הטלפון. הטבלה מתעדכנת כשהתנועה נגמרת.</div>';
      el.innerHTML = head + tbl;
    }
    render();
    setInterval(function () { if (!mon) render(); }, 1000);
  }

  function bootAll() {
    var list = document.querySelectorAll('.tych[data-tych-spin]');
    for (var i = 0; i < list.length; i++) boot(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
